/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  Form, Segment, Divider, Modal, Button,
  Icon, Header, Grid, Select, Container
} from "semantic-ui-react";
import Constants from "../utilities/Constants";
import Strings from "../utilities/Strings";
import Utils from "../utilities/Utils";
import { withRouter } from "react-router-dom";

const UtilsInstance = new Utils();

class EditTags extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      channelDropdownOptions: [],
      selectedItemAddress: -1,
      selectedChannel: -1,
      devices: [],
      devicesDropdownOptions: [],
      openDeleteTagsConfirm: false,
      formInputTag: ""
    };
  }

  retrieveAvailableChannels = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "activeChannels", { mode: "cors" })
      .then(res => res.json())
      .then(data => {
        const channelDropdownOptions = [];

        if (data.channel1) {
          channelDropdownOptions.push({
            key: 1,
            value: 1,
            text: Strings.CHANNEL_1
          });
        }

        if (data.channel2) {
          channelDropdownOptions.push({
            key: 2,
            value: 2,
            text: Strings.CHANNEL_2
          });
        }

        if (data.channel3) {
          channelDropdownOptions.push({
            key: 3,
            value: 3,
            text: Strings.CHANNEL_3
          });
        }

        if (data.channel4) {
          channelDropdownOptions.push({
            key: 4,
            value: 4,
            text: Strings.CHANNEL_4
          });
        }

        this.setState({ channelDropdownOptions: channelDropdownOptions });
      });
  }

  retrieveDevicesDropdownOptionsList = async (channel) => {
    fetch(Constants.REQUEST_IP_ADDRESS + "liveList/" + channel, { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        devices: data.sort(UtilsInstance.sortBy("address", false, parseInt))
      }, () => {
        this.buildDevicesDropdownOptionsList();
      }));
  }

  // ------------------ Tag Submit ------------------
  handleSubmitNewTag = () => {
    if (this.state.selectedChannel === -1) {
      alert(Strings.CHOOSE_A_CHANNEL_FIRST);
    }
    else if (this.state.selectedItemAddress === -1) {
      alert(Strings.CHOOSE_A_DEVICE_FIRST);
    }
    else {
      let newTagInfo = {};

      // Save the device address and new tag to be modified
      for (let i = 0; i < this.state.devices.length; i++) {
        if (this.state.devices[i].address === this.state.selectedItemAddress) {
          newTagInfo.channel = this.state.selectedChannel;
          newTagInfo.address = this.state.selectedItemAddress.toString(16); // Send the address as hexadecimal
          newTagInfo.tag = this.state.formInputTag;
          break;
        }
      }

      let data = JSON.stringify(newTagInfo);

      fetch(Constants.REQUEST_IP_ADDRESS + "editTag_POST/" + this.state.selectedChannel, {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: data,
        mode: "cors"
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          alert(Strings.CHANGE_TAG_SUCCESS);
          // After changing the tag, get the new data
          this.setState({
            selectedItemAddress: -1,
            formInputTag: ""
          }, () => {
            this.retrieveDevicesDropdownOptionsList(this.state.selectedChannel);
          });
        })
        .catch((error) => {
          alert(Strings.CHANGE_TAG_FAILURE + Strings.ERROR_REASON + error);
        });
    }
  }

  // ------------------------ Channel Dropdown ------------------------
  handleChannelDropdownChange = (event, info) => {
    this.setState({
      selectedChannel: info.value,
      selectedItemAddress: -1,
      formInputTag: ""
    }, () => {
      let tagsGridElement = document.getElementById("tags-grid");
      let channelsElement = document.getElementById("channel-segment");

      if (this.state.selectedChannel !== -1) {
        tagsGridElement.style.visibility = "visible";
        tagsGridElement.style.display = "block";
        channelsElement.style.marginBottom = "2vh";

        this.retrieveDevicesDropdownOptionsList(this.state.selectedChannel);
      }
      else {
        tagsGridElement.style.visibility = "hidden";
        tagsGridElement.style.display = "none";
      }
    });
  }

  // ------------------------ Device Tag  ------------------------
  buildDevicesDropdownOptionsList = () => {
    let dropdownOptionsList = [];

    for (let i = 0; i < this.state.devices.length; i++) {
      if (this.state.devices[i].isMaster) {
        dropdownOptionsList.push({
          key: this.state.devices[i].address,
          value: this.state.devices[i].address,
          text: "Manager: " + this.state.devices[i].address
        });
      }
      else {
        dropdownOptionsList.push({
          key: this.state.devices[i].address,
          value: this.state.devices[i].address,
          text: "Device: " + this.state.devices[i].address
        });
      }
    }

    this.setState({ devicesDropdownOptions: dropdownOptionsList });
  }

  // When a dropdown option is selected, save the PROFIBUS address of the device on the state
  // So we can use it later to send to the server
  handleDevicesDropwdownItemClick = (event, info) => {

    if (info.value === "") {
      this.setState({
        selectedItemAddress: -1,
        formInputTag: ""
      });
    }
    else {
      for (let i = 0; i < this.state.devices.length; i++) {
        if (this.state.devices[i].address === info.value) {
          let deviceTag = "";

          if (this.state.devices[i].tag !== null) {
            deviceTag = this.state.devices[i].tag;
          }

          this.setState({
            selectedItemAddress: this.state.devices[i].address,
            formInputTag: deviceTag
          });

          break;
        }
      }
    }
  }

  onChangeTagInput = (e, data) => {
    this.setState({ formInputTag: data.value });
  }

  // ------------------------ Delete Tags ------------------------
  openDeleteTagsConfirm = () => this.setState({ openDeleteTagsConfirm: true });

  closeDeleteTagsConfirm = () => this.setState({ openDeleteTagsConfirm: false });

  handleDeleteTagsClick = () => {
    if (this.state.selectedChannel === -1) {
      alert(Strings.CHOOSE_A_CHANNEL_FIRST);
    }
    else {
      this.openDeleteTagsConfirm();
    }
  }

  handleDeleteTags = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "resetTag_POST/" + this.state.selectedChannel, {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify({ channel: this.state.selectedChannel }),
      mode: "cors"
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.REMOVE_TAG_SUCCESS);
        this.setState({
          selectedItemAddress: -1,
          formInputTag: ""
        }, () => {
          this.retrieveDevicesDropdownOptionsList(this.state.selectedChannel);
        });
      })
      .catch((error) => {
        alert(Strings.REMOVE_TAG_FAILURE + Strings.ERROR_REASON + error);
      })
      .finally(this.closeDeleteTagsConfirm);
  }

  // ------------------------ Import/Export Tags ------------------------
  exportTags = () => {
    if (this.state.selectedChannel === -1) {
      alert(Strings.CHOOSE_A_CHANNEL_FIRST);
    }
    else {
      fetch(Constants.REQUEST_IP_ADDRESS + "liveList/" + this.state.selectedChannel, { mode: "cors" })
        .then(res => res.json())
        .then(data => {

          let tagsInfo = {
            "channel": this.state.selectedChannel,
            "Tags": []
          };

          for (let i = 0; i < data.length; i++) {
            tagsInfo.Tags.push({
              "address": data[i].address,
              "tag": (data[i].tag == null) ? "" : data[i].tag
            });
          }

          let tagsJSONInfo = JSON.stringify(tagsInfo);

          let dataStr = "data:application/json;charset=utf-8," + encodeURIComponent(tagsJSONInfo);
          let downloadAnchorNode = document.createElement("a");
          downloadAnchorNode.setAttribute("href", dataStr);
          downloadAnchorNode.setAttribute("download", "tags-canal-" + this.state.selectedChannel + ".json");
          document.body.appendChild(downloadAnchorNode); // required for firefox
          downloadAnchorNode.click();
          downloadAnchorNode.remove();
        });
    }
  }

  importTags = () => {
    let fileInput = document.getElementById("import-tags-input-file");

    if (fileInput.files[0] !== undefined && fileInput.files[0] !== null) {
      let file = fileInput.files[0];
      let fileReader = new FileReader();

      // Import the tags information when the file is ready to be read
      fileReader.onload = (event) => {
        try {
          let tagsJSONObject = JSON.parse(event.target.result);
          let isChannelOk = tagsJSONObject.channel !== undefined && tagsJSONObject.channel !== null;
          let areTagsOk = tagsJSONObject.Tags !== undefined && tagsJSONObject.Tags !== null;

          if (areTagsOk && isChannelOk) {
            // If there are no problems, convert the addresses to hex
            for (let i = 0; i < tagsJSONObject.Tags.length; i++) {
              tagsJSONObject.Tags[i].address = tagsJSONObject.Tags[i].address.toString(16); // Send the address as hexadecimal
            }

            // And save them
            let networkData = JSON.stringify({
              channel: tagsJSONObject.channel,
              Tags: tagsJSONObject.Tags
            });

            // Try to save the nodes of the network
            fetch(Constants.REQUEST_IP_ADDRESS + "importTags_POST/" + this.state.selectedChannel, {
              method: "POST",
              headers: {
                "Content-Type": "application/json;charset=UTF-8"
              },
              body: networkData
            })
              .then(UtilsInstance.checkStatus)
              .then(() => {
                alert(Strings.IMPORT_TAGS_SUCCESS_1 + this.state.selectedChannel + Strings.IMPORT_TAGS_SUCCESS_2);
                this.setState({
                  selectedItemAddress: -1,
                  formInputTag: ""
                }, () => {
                  this.retrieveDevicesDropdownOptionsList(this.state.selectedChannel);
                });
              })
              .catch((error) => {
                alert(Strings.IMPORT_TAGS_FAILURE + error);
              });
          }
          else {
            alert(Strings.IMPORT_TAGS_FAILURE + Strings.INVALID_OR_CORRUPT_FILE);
          }
        }
        catch (error) {
          alert(Strings.IMPORT_TAGS_FAILURE + Strings.INVALID_OR_CORRUPT_FILE);
        }
      };

      fileReader.readAsText(file);
    }
    else {
      alert(Strings.PLEASE_SELECT_TAG_FILE);
    }
  }

  // Verifies if the user has the credentials to be logged in
  // If he does he is re-directed to the configuration page
  // If he doesn't he is re-directed to the login page
  isUserLoggedIn = () => {
    if (sessionStorage.auth !== Constants.AUTH_STR) {
      this.props.history.push({ pathname: "/login" });
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.isUserLoggedIn();
    this.retrieveAvailableChannels();
  }

  render() {

    return (
      <div>
        <Container>
          <Segment id="channel-segment">
            <Divider horizontal>{Strings.CHANNEL}</Divider>
            <Select
              fluid
              style={selectStyle}
              placeholder={Strings.CHANNELS}
              options={this.state.channelDropdownOptions}
              onChange={this.handleChannelDropdownChange} />

            <Grid id="tags-grid" style={tagsGridStyle} columns={2} doubling verticalAlign="middle">

              <Grid.Column>
                <Segment>
                  <Divider horizontal>{Strings.ADD_ALTER_TAGS}</Divider>
                  <Form onSubmit={this.handleSubmitNewTag}>
                    <Form.Dropdown
                      placeholder={Strings.CHOOSE_DEVICE}
                      fluid
                      lazyLoad
                      search
                      clearable
                      selection
                      scrolling
                      options={this.state.devicesDropdownOptions}
                      onChange={this.handleDevicesDropwdownItemClick}
                    />
                    <Form.Input
                      value={this.state.formInputTag}
                      placeholder={Strings.NEW_TAG}
                      onChange={this.onChangeTagInput} />

                    <Form.Button color="teal">{Strings.SAVE}</Form.Button>
                  </Form>
                </Segment>

                <Segment>
                  <Divider horizontal>{Strings.REMOVE_ALL_TAGS}</Divider>
                  <Form onSubmit={this.handleDeleteTagsClick}>
                    <Form.Button color="teal">{Strings.REMOVE}</Form.Button>
                  </Form>
                </Segment>
              </Grid.Column>

              <Grid.Column>

                <Segment>
                  <Divider horizontal>{Strings.IMPORT_TAGS}</Divider>
                  <Form onSubmit={this.importTags}>
                    <Form.Input id="import-tags-input-file" type="file" accept=".json" />
                    <Button color="teal" type="submit" content={Strings.IMPORT} />
                  </Form>
                </Segment>

                <Segment>
                  <Divider horizontal>{Strings.EXPORT_TAGS}</Divider>
                  <Button
                    color="teal"
                    onClick={this.exportTags}>
                    {Strings.EXPORT}
                  </Button>
                </Segment>

              </Grid.Column>

              <Modal basic size='small' open={this.state.openDeleteTagsConfirm} >
                <Header icon='trash' content={Strings.REMOVE_ALL_TAGS} />
                <Modal.Content content={Strings.CONFIRM_REMOVE_ALL_TAGS} />
                <Modal.Actions>
                  <Button color='red' onClick={this.closeDeleteTagsConfirm}>
                    <Icon name='remove' />
                    {Strings.NO}
                  </Button>
                  <Button color='green' onClick={this.handleDeleteTags}>
                    <Icon name='checkmark' />
                    {Strings.YES}
                  </Button>
                </Modal.Actions>
              </Modal>

            </Grid>
          </Segment>
        </Container>
      </div>
    );
  }
}

const selectStyle = {
  marginBottom: "2vh"
};

const tagsGridStyle = {
  textAlign: "center",
  display: "none",
  visibility: "hidden"
};

export default withRouter(EditTags);